import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity } from 'react-native';
import { MdDirectionsTransit } from 'react-icons/md';
import ItineraryItemCard from './ItineraryItemCard';
import PlatformIcon from '../common/PlatformIcon';
import { ORANGE_ACTION } from '../../constants/colors';

export interface LodgingCardProps {
  title: string;
  note?: string;
  time?: string;
  hotelName?: string;
  address?: string;
  checkIn?: string;
  checkOut?: string;
  transportNote?: string;
  // Ad injection (optional): provide custom React content to render as an inline ad block
  adContent?: React.ReactNode;
  // Hide the default demo ad block
  hideAd?: boolean;
  // Optional: handle CTA click in the default demo ad
  onAdPress?: () => void;
}

const LodgingCard: React.FC<LodgingCardProps> = ({ title, note, hotelName, address, checkIn, checkOut, transportNote, adContent, hideAd, onAdPress }) => {
  const [noteExpanded, setNoteExpanded] = React.useState(false);
  const shouldShowToggle = (() => {
    if (!note) return false;
    try {
      const len = String(note).length;
      if (len >= 80) return true;
      if (String(note).includes('\n')) return true;
      if ((String(note).match(/\s+/g) || []).length > 12) return true;
      return false;
    } catch {
      return false;
    }
  })();
  return (
    <ItineraryItemCard>
      <View style={styles.rowTop}>
        <Text style={styles.title}>{title}</Text>
        <View style={styles.actions}>
          <PlatformIcon name="hotel" size={16} color={ORANGE_ACTION} />
        </View>
      </View>
      <View style={styles.metaRow}>
        {hotelName ? <Text style={styles.metaText}>{hotelName}</Text> : null}
        {checkIn || checkOut ? (
          <Text style={styles.metaText}>{(checkIn || '') + (checkOut ? ` → ${checkOut}` : '')}</Text>
        ) : null}
      </View>
      {address ? <Text style={styles.metaText}>{address}</Text> : null}
      {transportNote ? (
        <View style={styles.infoRow}>
          <View style={styles.iconWrapper}>
            {React.createElement(MdDirectionsTransit as any, { size: 16, color: '#9CA3AF' })}
          </View>
          <Text style={styles.infoText} numberOfLines={3}>{transportNote}</Text>
        </View>
      ) : null}
      {note ? (
        <>
          <Text style={styles.note} numberOfLines={noteExpanded ? undefined : 2}>{note}</Text>
          {shouldShowToggle ? (
            <TouchableOpacity style={styles.noteToggleButton} onPress={() => setNoteExpanded(v => !v)}>
              <Text style={styles.noteToggleText}>{noteExpanded ? '收起 ▴' : '展开 ▾'}</Text>
            </TouchableOpacity>
          ) : null}
        </>
      ) : null}

      {/* Inline Ad Block - temporary hardcoded preview; can be overridden via adContent prop */}
      {/* Ad slot: render only when caller passes explicit content and not hidden */}
      {!hideAd && adContent ? (
        <View style={{ marginTop: 12 }}>
          {typeof adContent === 'string' || typeof adContent === 'number' ? (
            <Text>{String(adContent)}</Text>
          ) : Array.isArray(adContent) ? (
            adContent.map((c, i) => (typeof c === 'string' || typeof c === 'number' ? <Text key={i}>{String(c)}</Text> : c))
          ) : (
            adContent
          )}
        </View>
      ) : null}
    </ItineraryItemCard>
  );
};

const styles = StyleSheet.create({
  rowTop: { flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' },
  title: { fontSize: 16, fontWeight: '600', color: '#111827' },
  actions: { flexDirection: 'row', alignItems: 'center' },
  metaRow: { flexDirection: 'row', alignItems: 'center', marginTop: 6 },
  metaText: { marginRight: 10, color: '#6B7280' },
  infoRow: { flexDirection: 'row', alignItems: 'flex-start', marginTop: 6, gap: 8 },
  iconWrapper: { width: 16, height: 16, justifyContent: 'center', alignItems: 'center', flexShrink: 0, marginTop: 2 },
  infoText: { color: '#6B7280', flex: 1, lineHeight: 18, fontSize: 13 },
  note: { marginTop: 8, color: '#6B7280' },
  noteToggleButton: { marginTop: 8, paddingVertical: 10, borderWidth: 1, borderColor: '#E5E7EB', borderRadius: 12, alignItems: 'center', justifyContent: 'center' },
  noteToggleText: { fontSize: 14, color: ORANGE_ACTION },
  // Ad styles
  adContainer: { marginTop: 12, padding: 12, borderRadius: 12, backgroundColor: '#FFF7ED', borderWidth: 1, borderColor: '#FED7AA' },
  adBadge: { flexDirection: 'row', alignItems: 'center', alignSelf: 'flex-start', backgroundColor: '#FFEDD5', paddingHorizontal: 8, paddingVertical: 2, borderRadius: 999 },
  adBadgeText: { marginLeft: 4, fontSize: 11, color: '#9A3412', fontWeight: '600' },
  adBody: { marginTop: 8, flexDirection: 'row', alignItems: 'center' },
  adTitle: { fontSize: 14, fontWeight: '700', color: '#7C2D12' },
  adSubtitle: { marginTop: 4, fontSize: 12, color: '#9A3412' },
  adCta: { paddingHorizontal: 12, paddingVertical: 8, borderRadius: 999, backgroundColor: '#EA580C' },
  adCtaText: { color: '#fff', fontWeight: '700', fontSize: 12 },
});

export default LodgingCard;
